import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useVerificationStore = defineStore('verification', () => {
  // 상태
  const verificationCandidates = ref([]);
  const selectedIds = ref([]);
  const jsonFilePath = ref('');
  const documentSummary = ref('');
  const documentStructure = ref([]);
  const verificationResults = ref([]);
  const isLoading = ref(false);
  const error = ref(null);
  const currentStep = ref(1); // Step 1: 추출, Step 2: 검증

  // 메서드
  const setCandidates = (candidates) => {
    verificationCandidates.value = candidates;
  };

  const setJsonFilePath = (path) => {
    jsonFilePath.value = path;
  };

  const toggleSelectedId = (id) => {
    // ID를 숫자로 명시적 변환
    const numericId = Number(id);
    const index = selectedIds.value.indexOf(numericId);
    if (index > -1) {
      selectedIds.value.splice(index, 1);
    } else {
      selectedIds.value.push(numericId);
    }
  };

  const selectAllIds = () => {
    // 모든 ID를 숫자로 명시적 변환하여 순수한 숫자 배열 생성
    selectedIds.value = verificationCandidates.value.map((c) => Number(c.id));
  };

  const deselectAllIds = () => {
    selectedIds.value = [];
  };

  const setVerificationResults = (results) => {
    verificationResults.value = results;
  };

  const setLoading = (loading) => {
    isLoading.value = loading;
  };

  const setError = (err) => {
    error.value = err;
  };

  const setCurrentStep = (step) => {
    currentStep.value = step;
  };

  const setDocumentSummary = (summary) => {
    documentSummary.value = summary;
  };

  const setDocumentStructure = (structure) => {
    documentStructure.value = structure;
  };

  const reset = () => {
    verificationCandidates.value = [];
    selectedIds.value = [];
    jsonFilePath.value = '';
    verificationResults.value = [];
    isLoading.value = false;
    error.value = null;
    currentStep.value = 1;
    documentSummary.value = '';
    documentStructure.value = [];
  };

  return {
    verificationCandidates,
    selectedIds,
    jsonFilePath,
    verificationResults,
    isLoading,
    error,
    currentStep,
    documentSummary,
    documentStructure,
    setCandidates,
    setJsonFilePath,
    toggleSelectedId,
    selectAllIds,
    deselectAllIds,
    setVerificationResults,
    setLoading,
    setError,
    setCurrentStep,
    setDocumentSummary,
    setDocumentStructure,
    reset,
  };
});
